<template>
  <div class="pro-wrapper">
    <div v-if="user !== null" class="pro-infoWrapper">
      <div class="pro-infoTitle">{{ $t("profile.personalInfo") }}</div>
      <div class="pro-unitInfoWrapper">
        <div class="pro-unitInfoTitle">{{ $t("profile.name") }}</div>
        <div class="pro-unitInfo">{{ user.Name }}</div>
        <div class="pro-unitEdit">
          <ChangeNameDialog
            :header="$t('profile.nameDialogHeader')"
            :title="$t('profile.nameDialogTitle')"
            :placeholder="$t('profile.namePlaceholder')"
            :editName="user.Name"
            inputType="username"
            :onSubmit="updateUsername"
          />
        </div>
      </div>
      <div class="pro-unitInfoWrapper">
        <div class="pro-unitInfoTitle">{{ $t("profile.userEmail") }}</div>
        <div class="pro-unitInfo">{{ user.Email }}</div>
      </div>
      <div class="pro-unitInfoWrapper">
        <div class="pro-unitInfoTitle">{{ $t("profile.userPhone") }}</div>
        <div class="pro-unitInfo">{{ user.Phone }}</div>
        <div class="pro-unitEdit">
          <ChangeNameDialog
            :header="$t('profile.phoneDialogHeader')"
            :title="$t('profile.phoneDialogTitle')"
            :placeholder="$t('profile.phonePlaceholder')"
            :editName="user.Phone"
            inputType="phoneNumber"
            :onSubmit="updatePhoneNumber"
          />
        </div>
      </div>
      <div class="pro-unitInfoWrapper">
        <div class="pro-unitInfoTitle">{{ $t("profile.registerDate") }}</div>
        <div class="pro-unitInfo">{{ user.RegAt }}</div>
      </div>
      <div class="pro-unitInfoWrapper">
        <div class="pro-unitInfoTitle">{{ $t("profile.unit") }}</div>
        <div class="pro-unitInfo">
          <v-select
            v-model="select"
            item-text="branch"
            item-value="id"
            dense
            style="margin-top:0px"
            :items="branches"
          ></v-select>
        </div>
      </div>
    </div>
    <div v-else class="pro-infoLoadingWrapper">
      <v-progress-circular
        :size="40"
        :width="3"
        color="#787ff7"
        indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import ChangeNameDialog from "../components/ChangeNameDialog";
import { format } from "date-fns";
import { mapActions, mapState } from "vuex";
export default {
  name: "Profile",
  components: {
    ChangeNameDialog,
  },
  data: () => ({
    buyInfo: null,
    selected: { id: 1, branch: "Сонгоогүй" },
    branches: [
      { id: 1, branch: "Сонгоогүй" },
      { id: 2, branch: "ЗахиргааХуульНийтийн үйлчилгээ" },
      { id: 3, branch: "Уул уурхай" },
      { id: 4, branch: "Хэвлэл мэдээлэл" },
      { id: 5, branch: "Боловсрол" },
      { id: 6, branch: "Эрүүл мэнд" },
      { id: 7, branch: "Санхүү/Худалдаа" },
      { id: 8, branch: "Нийгэм" },
      { id: 9, branch: "Бусад" },
    ],
  }),
  computed: {
    select: {
      get() {
        return this.branches.filter(
          (item) => item.id === this.user.BranchID
        )[0];
      },
      set(id) {
        this.updateBranch(id);
      },
    },
    ...mapState(["user"]),
    getToken: function() {
      return this.$cookie.get("token");
    },
    getUserFormatDate: function() {
      var currentDate = new Date(this.user.RegAt);
      currentDate.setHours(currentDate.getHours());
      return format(currentDate, "yyyy/MM/dd");
    },
  },
  mounted() {},
  methods: {
    ...mapActions([
      "showErrorMessage",
      "showSuccessMessage",
      "showWarningMessage",
      "updateUser",
      "checkError",
    ]),

    getPurchasedInfo() {
      const headers = { token: this.getToken };
      axios
        .get(`${process.env.VUE_APP_BASE_URL}/getallpurchasedinfo`, {
          headers,
        })
        .then((response) => {
          var data = response.data.data.List[0];
          data.ValidUntil = format(new Date(data.ValidUntil), "yyyy/MM/dd");
          data.BoughtAt = format(new Date(data.BoughtAt), "yyyy/MM/dd");
          this.buyInfo = data;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.checkError(error);
        });
    },
    async updateUsername(name) {
      let info = {
        name: name,
        phone: this.user.Phone,
        branch_id: this.user.BranchID,
      };
      await this.updateUserInfo(info);
    },
    async updatePhoneNumber(number) {
      let info = {
        name: this.user.Name,
        phone: number,
        branch_id: this.user.BranchID,
      };
      await this.updateUserInfo(info);
    },
    async updateBranch(branchId) {
      let info = {
        name: this.user.Name,
        phone: this.user.Phone,
        branch_id: branchId,
      };
      await this.updateUserInfo(info);
    },
    async updateUserInfo(info) {
      const headers = { token: this.getToken };

      try {
        let response = await axios.put(
          `${process.env.VUE_APP_BASE_URL}/v2/customer/${this.user.CustomerID}`,
          info,
          {
            headers,
          }
        );

        if (response.status === 200) {
          this.showSuccessMessage({
            message: "Амжилттай солигдлоо.",
            timeout: 3000,
          });
          this.updateUser(this.getToken);
        } else {
          this.showWarningMessage({
            message: "Амжилтгүй боллоо. Интэрнет холболтоо шалгана уу.",
            timeout: 3000,
          });
        }
      } catch (error) {
        this.loading = false;
        this.checkError(error);
      }
    },
  },
};
</script>
<style scoped>
.pro-wrapper {
  display: flex;
  max-width: 1140px;
  width: 100%;
}

.pro-infoWrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.pro-infoTitle {
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: #000000;
  margin-bottom: 15px;
}

.pro-unitInfoWrapper {
  display: flex;
  padding: 15px;
  border-top: 1px solid #e5e5e5;
  width: 100%;
}

.pro-unitInfoTitle {
  width: 40%;
  font-size: 14px;
  line-height: 24px;
  color: #000000;
}

.pro-unitInfo {
  width: 50%;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #000000;
}
.pro-unitEdit {
  width: 10%;
  display: flex;
  justify-content: flex-end;
}
.pro-infoLoadingWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
</style>
